/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const VIsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <g
                id="Temporary-pages"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="smallcard_visa">
                    <g
                        id="Visa"
                        style={{ mixBlendMode: 'multiply' }}
                        transform="translate(1, 6.000000)"
                    >
                        <polyline
                            id="Fill-2"
                            fill="#004F8B"
                            points="12.4620762 10.9656546 14.2354914 0.560170508 17.0717198 0.560170508 15.2971087 10.9656546 12.4620762 10.9656546"
                        />
                        <path
                            d="M25.5837937,0.816306115 C25.02189,0.60541781 24.1414612,0.379380629 23.0417724,0.379380629 C20.2394296,0.379380629 18.2650925,1.79061806 18.248349,3.81319237 C18.2326022,5.3083466 19.6577925,6.14253144 20.733562,6.64025176 C21.8374367,7.15013104 22.2087835,7.47543323 22.2034017,7.93089616 C22.1964252,8.62834245 21.321777,8.94706684 20.5065282,8.94706684 C19.3713591,8.94706684 18.768394,8.78939893 17.8369374,8.40090998 L17.4713711,8.2354683 L17.0733145,10.5648074 C17.7358785,10.8552273 18.9609442,11.1069777 20.2326525,11.119934 C23.2141905,11.119934 25.1494595,9.72484204 25.1715848,7.5649312 C25.1823485,6.38132557 24.4264993,5.48036608 22.7904207,4.73787181 C21.7989666,4.25649634 21.1918156,3.93518069 21.198194,3.4478254 C21.198194,3.01528511 21.7120599,2.55284573 22.8225124,2.55284573 C23.7499824,2.53849416 24.4217155,2.74061206 24.945149,2.95150037 L25.1992913,3.07149542 L25.5837937,0.816306115"
                            id="Fill-3"
                            fill="#004F8B"
                        />
                        <path
                            d="M32.8566497,0.570136874 L30.6650458,0.570136874 C29.9861369,0.570136874 29.4780516,0.755311955 29.1798579,1.43302484 L24.967673,10.9690432 L27.9460218,10.9690432 C27.9460218,10.9690432 28.4329784,9.68677052 28.5432065,9.40532034 C28.868708,9.40532034 31.7617447,9.40970555 32.1753489,9.40970555 C32.2602623,9.77387656 32.5205838,10.9690432 32.5205838,10.9690432 L35.1523024,10.9690432 L32.8566497,0.570136874 M29.3594518,7.27690322 C29.5938608,6.67732664 30.4894384,4.36811963 30.4894384,4.36811963 C30.4724956,4.39582613 30.7222527,3.76575247 30.8653697,3.37507092 L31.0571226,4.27224319 C31.0571226,4.27224319 31.6002896,6.75606093 31.7137068,7.27690322 L29.3594518,7.27690322"
                            id="Fill-4"
                            fill="#004F8B"
                        />
                        <path
                            d="M10.083304,0.567744946 L7.3064751,7.66359822 L7.01067335,6.22146506 C6.49381761,4.55907521 4.88325286,2.75815287 3.08252985,1.8565954 L5.62156126,10.9566849 L8.62243406,10.9532963 L13.0875654,0.567744946 L10.083304,0.567744946"
                            id="Fill-5"
                            fill="#004F8B"
                        />
                        <path
                            d="M4.73056814,0.561366472 L0.1572021,0.561366472 L0.120924528,0.777835942 C3.67911652,1.63912929 6.0333715,3.72050517 7.01067335,6.22146506 L6.01622935,1.43980197 C5.8444092,0.780825852 5.34648956,0.584289114 4.73056814,0.561366472"
                            id="Fill-6"
                            fill="#ED9F2D"
                        />
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

VIsmallcard.defaultProps = { className: '' };

VIsmallcard.propTypes = { className: PropTypes.string };

export default VIsmallcard;
